import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getRelatedBlogs } from "./RelatedBlogsApi";


const initialState = {
    blogs: [],
    isLoading: false,
    isError: false,
    error: ''
}

export const fetchReatedBlogs = createAsyncThunk("blogs/relatedBlogs", async({id, tags}) =>{
    const blogs = await getRelatedBlogs({id, tags});
    return blogs
})

const RelatedBlogsSlice = createSlice({
    name: "blogs",
    initialState,
    extraReducers: (builder) =>{
        builder
        .addCase(fetchReatedBlogs.pending, (state) =>{
            state.isError = false;
            state.isLoading = true; 
        })
        .addCase(fetchReatedBlogs.fulfilled, (state,action) =>{
            state.isLoading = false; 
            state.blogs = action.payload;
        })
        .addCase(fetchReatedBlogs.rejected, (state,action) =>{
            state.isLoading = false; 
            state.blogs = [];
            state.isError = true;
            state.error = action.error?.message;
        })
    }
})

export default RelatedBlogsSlice.reducer;